import React from "react";
import MenuLayout from "../../components/MenuLayout/MenuLayout";
import Button from "../../components/Button/Button";
import { sortByOrderAscending } from "../../helper/helper";
import { useDispatch } from "react-redux";
import { setIsComing } from "../../../../../../../redux/companyDataSlice";
const HoppersRestaurantMenuPage = ({ components }) => {
    const dispatch = useDispatch()
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantMenuPage-header":
                return <div className="HoppersRestaurantMenuPage-header">{component?.Props?.text}</div>
            case "HoppersRestaurantMenuPage-subheader":
                return <div className="HoppersRestaurantMenuPage-subheader">{component?.Props?.text}</div>
            case "HoppersRestaurantMenuPage-menu":
                return <div className="HoppersRestaurantMenuPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <MenuLayout
                                data={data}
                                key={key} />
                        )
                    })}
                </div>
            case "HoppersRestaurantMenuPage-button":
                return <div className="HoppersRestaurantMenuPage-btncont">
                    <Button
                        text={component?.Props?.btnText}
                        width={component?.Props?.width}
                        onClick={() => {
                            if (component?.Props?.href && component?.Props?.href?.includes("https://")) {
                                window.open(component?.Props?.href, '_blank')
                            } else {
                                dispatch(setIsComing(true))
                            }
                        }} />
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersRestaurantMenuPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HoppersRestaurantMenuPage